import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Pagination } from "react-bootstrap";
import moment from "moment";
import { API_END_POINT } from "../config";
import Cookie from "js-cookie";
const token = Cookie.get("waffle_world_access_token");
import { JWT_SECRET_TOKEN } from "../config";
const jwt = require("jsonwebtoken");
import HasRole from "../hoc/HasRole";

export default class CoverBanner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      banners: [],
      activePage: 1,
      pages: 1,
      q: "",
      responseMessage: "Loading Banners...",
    };
  }
  componentWillMount() {
    this.fetchBanners();
  }

  fetchBanners = () => {
    axios
      .get(`${API_END_POINT}/api/banners`, { headers: { "auth-token": token } })
      .then((response) => {
        let SortedArray = response.data.objects;
        SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
        this.setState({
          banners: SortedArray,
          pages: Math.ceil(response.data.objects.length / 10),
          responseMessage: "No Banners Found...",
        });
      });
  };

  // const requestParams = {
  //   "userId": userId,
  // }

  deleteBanner(bannerId, index) {
    const requestParams = {
      bannerId: bannerId,
    };
    if (confirm("Sicher das Sie den Banner löschen möchten?")) {
      const tokenx = jwt.sign({ payload: requestParams }, JWT_SECRET_TOKEN, {
        expiresIn: "1h",
      });
      axios
        .delete(`${API_END_POINT}/api/banners/delete`, {
          data: requestParams,
          headers: { "auth-token": tokenx },
        })
        .then((response) => {
          const banners = this.state.banners.slice();
          banners.splice(index, 1);
          this.setState({ banners });
          window.alert(response.data.msg);
        });
    }
  }

  handleSelect(page) {
    axios.get(`/api/area?offset=${(page - 1) * 10}`).then((response) => {
      this.setState({
        areas: response.data.items,
        activePage: page,
      });
    });
  }

  handleSearch() {
    const { q } = this.state;
    if (q.length) {
      this.setState({
        loading: true,
        banners: [],
        responseMessage: "Loading Banners...",
      });
      axios
        .get(`${API_END_POINT}/api/banners/search`, {
          params: { searchWord: this.state.q },
          headers: { "auth-token": token },
        })
        .then((response) => {
          let SortedArray = response.data.searchedItems;
          SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            banners: SortedArray,
            loading: false,
            responseMessage: "No Banners Found...",
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            responseMessage: "No Banners Found...",
          });
        });
    }
  }

  render() {
    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row space-1">
            <div className="col-sm-4">
              <h3>Liste der Banners</h3>
            </div>
            <div className="col-sm-4">
              <div className="input-group">
                <input
                  className="form-control"
                  type="text"
                  name="search"
                  placeholder="Enter keyword"
                  value={this.state.q}
                  // onChange={(event) => this.setState({q: event.target.value})}
                  onChange={(event) =>
                    this.setState({ q: event.target.value }, () => {
                      if (this.state.q === "") {
                        this.fetchBanners();
                      }
                    })
                  }
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      this.handleSearch();
                    }
                  }}
                />
                <span className="input-group-btn">
                  <button
                    type="button"
                    onClick={() => this.handleSearch()}
                    className="btn btn-info search-btn"
                  >
                    Suchen
                  </button>
                </span>
              </div>
            </div>

            <div className="col-sm-4 pull-right mobile-space">
              <Link to="/banner/banner_form">
                <button type="button" className="btn btn-success">
                  Neuen Banner hinzufügen
                </button>
              </Link>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Nr. #</th>
                  <th>Desktop Banner</th>
                  <th>Tablet Banner</th>
                  <th>Mobile Banner</th>
                  <th>Name</th>
                  <th>Banner Typ</th>
                  <th>Datum</th>
                </tr>
              </thead>
              <tbody>
                {this.state.banners && this.state.banners.length >= 1 ? (
                  this.state.banners.map((banner, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {
                          <img
                            style={{ height: "50px", width: "70px" }}
                            src={
                              banner.image
                                ? banner.image
                                : banner.desktopImage
                                ? banner.desktopImage
                                : null
                            }
                          />
                        }
                      </td>
                      <td>
                        {
                          <img
                            style={{ height: "50px", width: "70px" }}
                            src={banner.tabletImage ? banner.tabletImage : null}
                          />
                        }
                      </td>
                      <td>
                        {
                          <img
                            style={{ height: "50px", width: "70px" }}
                            src={banner.mobileImage ? banner.mobileImage : null}
                          />
                        }
                      </td>
                      <td>{banner.name}</td>
                      <td>{banner.bannerType ? banner.bannerType : "-"}</td>
                      <td>{moment(banner.date).format("DD-MMM-YYYY")}</td>
                      <td>
                        <Link to={`/banner/edit_banner/${banner._id}`}>
                          <span
                            className="fa fa-edit"
                            aria-hidden="true"
                          ></span>
                        </Link>
                      </td>
                      <td>
                        <span
                          className="fa fa-trash"
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.deleteBanner(banner._id, index)}
                        ></span>
                      </td>
                      {/* </HasRole> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      {this.state.responseMessage}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* <div className="text-center">
            <Pagination prev next items={this.state.pages} activePage={this.state.activePage} onSelect={this.handleSelect.bind(this)}> </Pagination>
          </div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Banner.jsx